<template>
    <div class="faq" :class="{ open: open }">
        <div class="faq-header" @click="toggle()">
            <h3>{{ title }}</h3>
            <span class="faq-close">+</span>
        </div>
        <!-- end.faq-header -->
        <div class="faq-content">
            <slot name="content" ><p v-html="body">{{ body }}</p></slot>
        </div>
        <!-- end.faq-content -->
    </div>
</template>

<script>
// import Icon from "./Icon";

export default {
    props: ["title", "body"],
    components: {
        // Icon
    },
    methods: {
        toggle() {
            this.open = !this.open;
        }
    },
    data() {
        return {
            open: false
        };
    }
};
</script>
